export default {"src":"/_next/static/media/serviceLead-eng.0df9252d.svg","height":202,"width":678};